import React from 'react';
import { getCamelCase } from 'utils/formatUtils';

interface FormFieldProps {
  label: string;
  value: string;
  onChange: (e: any) => void;
  onPaste?: (e: any) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

export default function FormField(props: FormFieldProps): JSX.Element {
  return (
    <>
      <div className="w-full">
        <label htmlFor="databaseName" className="block text-sm font-medium leading-6 text-gray-900">
          {props.label}
        </label>
        <div className="mt-2">
          <input
            id={getCamelCase(props.label)}
            value={props.value}
            onChange={props.onChange}
            onPaste={props.onPaste}
            placeholder={props.placeholder ?? ''}
            required={props.required !== undefined ? props.required : false}
            disabled={props.disabled !== undefined ? props.disabled : false}
            className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
    </>
  );
}
